import React, { useState, createContext, useContext } from 'react';
interface DrawerContextType {
  isQuoteOpen: boolean;
  isUploadOpen: boolean;
  openQuote: () => void;
  closeQuote: () => void;
  openUpload: () => void;
  closeUpload: () => void;
}
const DrawerContext = createContext<DrawerContextType | undefined>(undefined);
export function DrawerProvider({
  children
}: {
  children: ReactNode;
}) {
  const [isQuoteOpen, setIsQuoteOpen] = useState(false);
  const [isUploadOpen, setIsUploadOpen] = useState(false);
  const openQuote = () => setIsQuoteOpen(true);
  const closeQuote = () => setIsQuoteOpen(false);
  const openUpload = () => setIsUploadOpen(true);
  const closeUpload = () => setIsUploadOpen(false);
  return <DrawerContext.Provider value={{
    isQuoteOpen,
    isUploadOpen,
    openQuote,
    closeQuote,
    openUpload,
    closeUpload
  }} data-id="element-588">
      {children}
    </DrawerContext.Provider>;
}
export function useDrawers() {
  const context = useContext(DrawerContext);
  if (context === undefined) {
    throw new Error('useDrawers must be used within a DrawerProvider');
  }
  return context;
}